import React, { Component } from 'react'
import UserList from './UserList.js'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import getLabel from '../../utilities/label.js'
import TitleBar from '../TitleBar'
import UserFilterScreen from '../UserFilterScreen'

export default class Attendees extends Component {
  constructor(props) {
    super(props)
    const userFilters = this.getUserFilters()
    this.state = {
      isRefreshing: false,
      showFilterScreen: false,
      userFilters: userFilters,
      users: this.filterUsers(userFilters)
    }
    this.refresh = this.refresh.bind(this)
    this.toggleFilterScreen = this.toggleFilterScreen.bind(this)
    this.toggleFilter = this.toggleFilter.bind(this)
    this.resetFilters = this.resetFilters.bind(this)
    this.updateSearchTerms = this.updateSearchTerms.bind(this)
    this.props.setActiveTab('attendees')
    window.trackPage('AttendeesScreen')
  }

  filterUsers(userFilters) {
    let users = this.props.users.event_users
    // 1. filter by user business card connections
    if (userFilters.connections) {
      users = users.filter((user) => {
        return user.is_biz_card
      })
    }
    // 2. filter to show only speakers
    if (userFilters.speakers) {
      users = users.filter((user) => {
        return user.is_speaker
      })
    }
    // 3. filter to show only sponsor users
    if (userFilters.sponsors) {
      users = users.filter((user) => {
        return user.is_sponsor
      })
    }
    // 4. filter to show only users in the selected user display lists
    if (_.some(userFilters.groups)) {
      let activeGroups = _.keys(userFilters.groups)
      activeGroups = activeGroups.filter((g) => userFilters.groups[g])
      users = users.filter((user) => {
        let usersGroups = user.user_display_list_attributes.map((g) => g.name)
        return _.some(usersGroups, (ug) => activeGroups.includes(ug))
      })
    }
    // 5. filter to show only users who match the given search terms
    if (userFilters.searchTerms) {
      let searchTerms = userFilters.searchTerms.toLowerCase()
      users = users.filter((user) => {
        let searchableText =
          `${ user.first_name } ` +
          `${ user.last_name } ` +
          `${ user.title } ` +
          `${ user.organization_name } `
        searchableText = searchableText.toLowerCase()
        return searchableText.indexOf(searchTerms) >= 0
      })
    }
    return users
  }

  getUserFilters() {
    const userFilters = JSON.parse(localStorage.getItem('user_filters'))
    return userFilters || this.getDefaultFilters()
  }

  getDefaultFilters() {
    return {
      connections: false,
      speakers: false,
      sponsors: false,
      groups: this.getGroupsObject()
    }
  }

  getGroupsObject() {
    const users = this.props.users.event_users
    let groups = users.map((u) => u.user_display_list_attributes)
    let groupNames = _.uniq(_.flatten(groups).map((g) => g.name))
    let groupObject = {}
    groupNames.forEach((name) => {
      groupObject[name] = false
    })
    return groupObject
  }

  refresh() {
    this.setState({ isRefreshing: true })
    this.props.getResource({
      key: 'users',
      update: true,
      callback: () => {
        this.setState(
          { isRefreshing: false },
          this.resetFilters
        )
      }
    })
  }

  toggleFilterScreen() {
    let { showFilterScreen } = this.state
    this.setState({
      showFilterScreen: !showFilterScreen
    })
  }

  toggleFilter(filterKey, secondaryKey) {
    let { userFilters } = this.state
    if (secondaryKey) {
      userFilters[filterKey][secondaryKey] = !userFilters[filterKey][secondaryKey]
    } else {
      userFilters[filterKey] = !userFilters[filterKey]
    }
    localStorage.setItem('user_filters', JSON.stringify(userFilters))
    this.updateUsers(userFilters)
  }

  updateSearchTerms(e) {
    e.preventDefault()
    let { userFilters } = this.state
    const { value } = e.currentTarget
    userFilters.searchTerms = value
    localStorage.setItem('user_filters', JSON.stringify(userFilters))
    this.updateUsers(userFilters)
  }

  updateUsers(userFilters) {
    let users = this.filterUsers(userFilters)
    this.setState({
      users: users,
      userFilters: userFilters
    })
  }

  resetFilters() {
    const userFilters = this.getDefaultFilters()
    localStorage.setItem('user_filters', JSON.stringify(userFilters))
    this.updateUsers(userFilters)
  }

  hasAnyFiltersActive() {
    const { userFilters } = this.state
    return (
      userFilters.connections ||
      userFilters.speakers ||
      userFilters.sponsors ||
      _.some(userFilters.groups)
    )
  }


  render() {
    const {
      users,
      isRefreshing,
      userFilters,
      showFilterScreen } = this.state
    const refreshButton =  isRefreshing ?
      '<i class=\'fa fa-refresh fa-spin\'></i>' :
      '<i class=\'fa fa-refresh\'></i>'
    const backButton = `<i class='fa fa-arrow-left'></i> ${ getLabel('back_button') }`
    const filterLabel = this.hasAnyFiltersActive() ?
      getLabel('filter_on') :
      getLabel('filter_off')

    if (showFilterScreen) {
      return (
        <UserFilterScreen
          toggleFilterScreen={ this.toggleFilterScreen }
          toggleFilter={ this.toggleFilter }
          userFilters={ userFilters }
          resetFilters={ this.resetFilters }
          users={ this.props.users.event_users } />
      )
    }

    return (
      <div>
        <TitleBar
          title={ getLabel({ key: 'attendee', plural: users.length }) }
          leftButtonLabel={ backButton }
          leftButtonAction={ () => window.history.back() }
          rightButtonLabel={ refreshButton }
          rightButtonAction={ this.refresh } />

        <input
          type='text'
          value={ userFilters.searchTerms }
          onChange={ this.updateSearchTerms }
          style={{ textAlign: 'center' }}
          placeholder={ getLabel('search') }
          className='form-control'>
        </input>
        <Link to='/scanner' className="biz-card-link">
          <div className="biz-card-div">{getLabel('scanner')} <i className="fa fa-id-card-o"></i></div>
        </Link>
        <a className="biz-link user-filter-link"
          onClick={ this.toggleFilterScreen } >
          <div className="biz-card-div user-filter-div">{ filterLabel } <i className="fa fa-filter"></i></div>
        </a>
        <UserList users={ users } />
      </div>
    )
  }
}
